import {
  // -- CREATE
  CREATE_FLOW_TASK_INTERACTION_CHECK_SUCCESS,
  CREATE_FLOW_TASK_INTERACTION_CHECK_FAILURE,
  // -- UPDATE
  UPDATE_FLOW_TASK_INTERACTION_CHECK_SUCCESS,
  UPDATE_FLOW_TASK_INTERACTION_CHECK_FAILURE,
  // -- DELETE
  DELETE_FLOW_TASK_INTERACTION_CHECK_SUCCESS,
  DELETE_FLOW_TASK_INTERACTION_CHECK_FAILURE
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

export const flowTaskInteractionChecks = (state = {}, action) => {
  switch (action.type) {
    // -- CREATE
    case CREATE_FLOW_TASK_INTERACTION_CHECK_FAILURE: {
      Logger.trace(
        LoggerTypes.WARN,
        '[REDUCER] flowTaskInteractionChecks.CREATE_FLOW_TASK_INTERACTION_CHECK_FAILURE()',
        { state, error: action.data }
      )
      return { ...state, error: action.data }
    }
    case CREATE_FLOW_TASK_INTERACTION_CHECK_SUCCESS: {
      Logger.trace(
        LoggerTypes.REDUCER,
        '[REDUCER] flowTaskInteractionChecks.CREATE_FLOW_TASK_INTERACTION_CHECK_SUCCESS()',
        {
          state,
          action
        }
      )

      return {
        ...state,
        ...action.data
      }
    }

    // -- UPDATE
    case UPDATE_FLOW_TASK_INTERACTION_CHECK_FAILURE: {
      Logger.trace(
        LoggerTypes.WARN,
        '[REDUCER] flowTaskInteractionChecks.UPDATE_FLOW_TASK_INTERACTION_CHECK_FAILURE()',
        { state, error: action.data }
      )
      return { ...state, error: action.data }
    }
    case UPDATE_FLOW_TASK_INTERACTION_CHECK_SUCCESS: {
      Logger.trace(
        LoggerTypes.REDUCER,
        '[REDUCER] flowTaskInteractionChecks.UPDATE_FLOW_TASK_INTERACTION_CHECK_SUCCESS()',
        { state, action }
      )

      return {
        ...state,
        ...action.data
      }
    }

    // -- DELETE
    case DELETE_FLOW_TASK_INTERACTION_CHECK_FAILURE: {
      Logger.trace(
        LoggerTypes.WARN,
        '[REDUCER] flowTaskInteractionChecks.DELETE_FLOW_TASK_INTERACTION_CHECK_FAILURE()',
        { state, error: action.data }
      )
      return { ...state, error: action.data }
    }
    case DELETE_FLOW_TASK_INTERACTION_CHECK_SUCCESS: {
      Logger.trace(
        LoggerTypes.REDUCER,
        '[REDUCER] flowTaskInteractionChecks.DELETE_FLOW_TASK_INTERACTION_CHECK_SUCCESS()',
        {
          state,
          action
        }
      )

      return {
        ...state,
        ...action.data
      }
    }

    default:
      return state
  }
}
